// Portfolio Grid filter: clicking a filter tag shows only cards/rows whose data-category matches,
// pure client-side (shared mechanics in filterGrid.js).
import initFilterGrid from './filterGrid';

export default function initPortfolioGrid() {
  initFilterGrid({
    rootSelector: '.section-portfolio-grid',
    tagSelector: '.section-portfolio-grid__filter-tag',
    itemSelector: '.portfolio-card, .portfolio-item',
    emptyText: (label) => 'No projects under \u201C' + label + '\u201D yet. Yours could be the first \u2014 try another service.',
  });
}
